var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15958_53021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 2C6.7925 2 2.3125 6.48 2.3125 12C2.3125 17.52 6.7925 22 12.3125 22C17.8325 22 22.3125 17.52 22.3125 12C22.3125 6.48 17.8325 2 12.3125 2ZM13.3125 17H11.3125V11H13.3125V17ZM13.3125 9H11.3125V7H13.3125V9Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 2C6.7925 2 2.3125 6.48 2.3125 12C2.3125 17.52 6.7925 22 12.3125 22C17.8325 22 22.3125 17.52 22.3125 12C22.3125 6.48 17.8325 2 12.3125 2ZM13.3125 17H11.3125V11H13.3125V17ZM13.3125 9H11.3125V7H13.3125V9Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15958_53021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoFill);
export default __webpack_public_path__ + "static/media/icon_info_fill.41ef4fdc6648d7f88e79d0d6a60c0d71.svg";
export { ForwardRef as ReactComponent };